const EngineeringTab = {
  data: () => ({
    engineeringItems: [{
      id: 0,
      title: '招标公告',
      status: '4,6,11,12,15',
      supEnterpriseIds: 25210,
      bidType: 'zhaobiaoNotice'
    }, {
      id: 1,
      title: '询价公告',
      status: '0',
      supEnterpriseIds: 25210,
      bidType: 'xunyuanNotice'
    }, {
      id: 2,
      title: '标书公告',
      status: '21,22,23,24',
      supEnterpriseIds: 25210,
      bidType: 'biaoshuNotice'
    }, {
      id: 3,
      title: '其他',
      status: '1,11,13,12,24',
      supEnterpriseIds: 25210,
      bidType: 'purchase'
    }]
  }),
  methods: {
    // onChange (e, that) {
    //   console.log(e)
    //   console.log(that.$refs.tabItem)
    // }
  }
}
export {
  EngineeringTab
}
